import { render, staticRenderFns } from "./AdditionalQuote.vue?vue&type=template&id=4ba81128&"
import script from "./AdditionalQuote.vue?vue&type=script&lang=js&"
export * from "./AdditionalQuote.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports